import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import InputText1 from "../components/InputText1";
import Button2 from "../components/Button2";
import { ReactComponent as SuccessIcon } from "../icons/success.svg";
import { ReactComponent as CloseIcon } from "../icons/close.svg";
import { v4 as uuidv4 } from 'uuid';
import { adminServices } from "../services/AdminServices";
import { dltService } from "../services/DltService";
import PDLList from "../components/PDLList";
import AlertModal from "../components/AlertModal";
import ConfirmationDialog from "../components/ConfirmationDialog";
import MerchantList from "../components/MerchantList";
import withAuthorization from "../components/withAuthorization";
import { useNavigate } from "react-router-dom";
import { ReactComponent as LoadIcon } from '../icons/load.svg';
document.title = 'PDL Administration | Fund Transfer';
const PdlToMerchant = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [referenceNo, setReferenceNo] = useState('');
  const [formSeqNo, setFormSeqNo] = useState('');
  const [amount, setAmount] = useState(0);

  const [pdlId, setPdlId] = useState(0);
  const [pdlNumber, setPdlNumber] = useState('');
  const [pdlFName, setPdlFName] = useState('');
  const [pdlLName, setPdlLName] = useState('');
  const [pdlWallet, setPdlWallet] = useState(0);
  const [openPDLList, setOpenPDLList] = useState(false);

  const [merchantId, setMerchantId] = useState(0);
  const [merchantFirstName, setMerchantFirstName] = useState('');
  const [merchantLastName, setMerchantLastName] = useState('');
  const [merchantPdlNumber, setMerchantPdlNumber] = useState('');
  const [merchantWallet, setMerchantWallet] = useState(0);
  const [openMerchant, setOpenMerchant] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState('');

  const navigate = useNavigate();
  
  useEffect(() => {
    generateReferenceNo();
  }, []);

  const generateReferenceNo = () => {
    const uuid = uuidv4();
    const refNo = uuid.split('-');
    setReferenceNo(refNo[4].toUpperCase());
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    window.location.href = "/fund-transfer";
  };

  const validateForm = () => {
    if (merchantId === 0) {
      setAlertMessage('Please select a Merchant');
      setShowAlert(true);
      return false;
    }

    if (pdlNumber === "") {
      setAlertMessage('Please select a PDL');
      setShowAlert(true);
      return false;
    }

    if (amount === "" || amount === "0" || amount === 0) {
      setAlertMessage('Please enter transfer amount');
      setShowAlert(true);
      return false;
    }

    if (amount <= 0) {
      setAlertMessage('Please enter a valid amount');
      setShowAlert(true);
      return false;
    }

    if (formSeqNo === '') {
      setAlertMessage('Please enter form sequence number');
      setShowAlert(true);
      return false;
    }

    return true;
  };

  const handleSelectedRow2 = (e) => {
    setMerchantFirstName(e.first_name);
    setMerchantLastName(e.last_name);
    setMerchantPdlNumber(e.pdl_number);
    setMerchantId(e.id);
    setMerchantWallet(e.wallet_amount);
    setOpenMerchant(false);
  };

  const handleCloseModal = () => {
    setShowAlert(false);
  };

  const submitForm = () => {
    if(validateForm()){
      if(isFormSubmitted) return;
      var payload = {
        "type": "pdl_to_merchant",
        "sourceId": pdlId,
        "destinationId": merchantId,
        "gross": amount,
        "form": formSeqNo
      }
      setIsFormSubmitted(true);
      dltService.postFundTransfer(null, payload).then((r)=>{
        if(r.status === 200){
          if(r.data?.status === "accepted"){
            openModal();
            setIsFormSubmitted(false);
          }
          else{
            setAlertMessage(r.data?.message || 'Unable to process fund transfer');
            setShowAlert(true);
            setIsFormSubmitted(false);
          }
        }
      }).catch((e)=>{
          setAlertMessage(e?.response?.data?.message || 'Error processing DLT fund transfer');
          setShowAlert(true);
          setIsFormSubmitted(false);
      })
  }
  };

  const handleSelectedRow = (e) => {
    setPdlNumber(e.pdlNumber);
    setPdlFName(e.firstName);
    setPdlLName(e.lastName);
    setPdlId(e.id);
    setOpenPDLList(false);
    setPdlWallet(e.walletAmount);
  };


  return (
    <div className="mainContainer">
      
      <ConfirmationDialog
        show={showConfirm}
        title={"PDL Padala"}
        message={confirmMessage}
        onCancel={() => { setShowConfirm(false); }}
        onConfirm={() => { window.location.href='/dashboard'; }}
      />
      <AlertModal
        show={showAlert}
        title="PDL Padala"
        message={alertMessage}
        onClose={handleCloseModal}
      />
      <PDLList
        token={localStorage.getItem('appToken')}
        isOpen={openPDLList}
        onClose={() => {setOpenPDLList(false)}}
        selectedInfo={handleSelectedRow}
        type={"pdltomerchant"}
      />
      <MerchantList
        token={localStorage.getItem('appToken')}
        isOpen={openMerchant}
        onClose={() => {setOpenMerchant(false)}}
        selectedInfo={handleSelectedRow2}
        type={"pdltomerchant"}
      />
      <div style={{ display: "flex", flexDirection: "row" }}>
        <Modal
          className="successModal"
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
        >
          <CloseIcon
            color="white"
            height="25px"
            className="alertCloseButton"
            onClick={closeModal}
          />
          <div className="flexRow">
            <div style={{ flex: 2, display: "flex", justifyContent: "center" }}>
              <SuccessIcon height="200px" color="white" />
            </div>
            <div style={{ flex: 3, display: "flex", justifyContent: "center" }}>
              <p className="medium">FUND TRANSFER SUCCESS!</p>
            </div>
          </div>
        </Modal>
        <div>

          <div style={{fontSize:'1.5rem', fontWeight:'bold', marginBottom:10, display: 'flex', justifyContent:'start',alignItems:'center'}}>
              <LoadIcon style={{ width: "50px", height: "50px", marginRight: "10px",background:'transparent' }} />
              PDL to Merchant Transfer
          </div>

          <p className="regular r t-darkgray">
            Fill in the details below to complete the transfer
          </p>

          
        </div>

        <div className="spacer"></div>
        <div style={{ alignContent: "end", marginRight:10 }}>
          <Button2 text={"Load Money"} onClick={()=>{ 
            navigate('/load-money');
           }}></Button2>
          <p>&nbsp;</p>
          <p className="sm">&nbsp;</p>
        </div>
        <div style={{ alignContent: "end", marginRight:10 }}>
        <Button2 text={"Load Merchant"} onClick={()=>{ 
              navigate('/load-merchant');
             }}></Button2>
             <p>&nbsp;</p>
             <p className="sm">&nbsp;</p>
        </div>
        <div style={{ alignContent: "end" }}>
          <Button2 text={"Fund Transfer"} onClick={()=>{ 
            navigate('/fund-transfer');
           }}></Button2>
           <p>&nbsp;</p>
           <p className="sm">2024.06.14 Version1</p>
        </div>
      </div>
      <div style={{ height: "20px" }}></div>
      <div className="flexRow" style={{ flex: "1" }}>
        <div className="column1">
          <div className="padalaSummaryCard">
            <div style={{ height: "15px" }}></div>
            <div className="padalaSummaryColumnContainer">
              <div className="padalaSummaryColumn">
                <p className="semibold r">Sender Information:</p>
                <div style={{marginBottom:5, marginTop: 5}}>
                  <input type="button" 
                    value={"Select a Pdl"}
                    onClick={()=>{ setOpenPDLList(true); }}
                    className="btn btn-primary btn-xs"
                    style={{
                      fontSize: 15,
                      fontVariant: 'all-petite-caps',
                    }}
                  />
              </div>
                <div style={{ height: "10px" }}></div>
                <div style={{ margin: "5px", flex: "1" }}>
                  <p className="semibold ">Pdl Number</p>
                  <p>{pdlNumber}</p>
                </div>
                <div style={{ margin: "5px", flex: "1" }}>
                  <p className="semibold ">First Name</p>
                  <p>{pdlFName}</p>
                </div>
                <div style={{ margin: "5px", flex: "1" }}>
                  <p className="semibold ">Last Name</p>
                  <p>{pdlLName}</p>
                </div>
                <div style={{ margin: "5px", flex: "1" }}>
                  <p className="semibold ">Wallet Amount</p>
                  <p>{"P " + pdlWallet.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</p>
                </div>
                
                <div style={{ margin: "5px", flex: "1" }}>
                  <InputText1
                  title="Form Sequence Number"
                  placeholder="Form Sequence Number"
                  name="formSeqNo"
                  value={formSeqNo}
                  onChange={(e)=>{
                    setFormSeqNo(e.target.value);
                  }}
                />
                </div>

                <div style={{ height: "20px" }}></div>
              </div>

              
            </div>
          </div>
        </div>
        <div className="column2">
          
          <div className="padalaSummaryCard">
            <p className="semibold l t-darkgray">Enter Amount:</p>
            <div style={{ height: "20px" }}></div>
            <div className="line2"></div>

            <div
              className="flexRow"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: 'center'
              }}
            >
              <p className="xxl medium t-darkgray" style={{marginTop: 35}}>Php &nbsp;</p>
              <input
                style={{ textAlign: "center", fontSize: "3rem" }}
                className="xxl semibold t-darkgray padalaAmount"
                type="number"
                placeholder="Enter amount..."
                value={amount}
                min={0}
                onChange={(e)=>{
                  if(e.target.value >pdlWallet){
                    return;
                  }
                  setAmount(e.target.value);
                }}
              ></input>
            </div>

            <div className="flexRow"
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 10,
                marginBottom: 20
              }}>
            </div>

            <div style={{ height: "15px" }}></div>
            <div className="padalaSummaryColumnContainer">
              <div className="padalaSummaryColumn">
                <p className="semibold r">Recipient information:</p>
                <div style={{marginBottom:5, marginTop: 5}}>
                  <input type="button" 
                    value={"Select a Merchant"}
                    onClick={()=>{ setOpenMerchant(true); }}
                    className="btn btn-primary btn-xs"
                    style={{
                      fontSize: 15,
                      fontVariant: 'all-petite-caps',
                    }}
                  />
                </div>
                <div style={{ margin: "5px", flex: "1" }}>
                  <p className="semibold ">PDL Number</p>
                  <p>{merchantPdlNumber}</p>
                </div>
                <div style={{ margin: "5px", flex: "1" }}>
                  <p className="semibold ">First Name</p>
                  <p>{merchantFirstName}</p>
                </div>
                <div style={{ margin: "5px", flex: "1" }}>
                  <p className="semibold ">Last Name</p>
                  <p>{merchantLastName}</p>
                </div>
                <div style={{ margin: "5px", flex: "1" }}>
                  <p className="semibold ">Transfer Amount</p>
                  <p>{amount}</p>
                </div>

                <div style={{ height: "20px" }}></div>
              </div>
            </div>

            <div className="flexRow" style={{marginTop: 20}}>
              <Button2
                text={"Cancel"}
                style={{ width: "200px", backgroundColor: "#cc2121" }}
                onClick={()=>{

                  setConfirmMessage("Are you sure you want to exit this page?");
                  setShowConfirm(true);

                } }
              />
              <div className="spacer"></div>

              <Button2
                text={"Proceed"}
                onClick={()=>{submitForm()}}
                style={{ width: "200px", backgroundColor: "#61dd48" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withAuthorization(PdlToMerchant,11);
